import React, { useEffect, useContext } from 'react';

import { styled } from '@mui/material/styles';
import { Box, Grid, Button } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import { LoadingContext } from 'common/utils/contexts';
import { getIsGuess } from 'common/utils/helpers/session';

import fondoLogin1 from 'resources/fondoLogin1.png';
import logotipo from 'resources/logotipo.svg';

import { createAccount } from './actions';
import { CreateAccountForm } from './components';
import * as selectors from './selectors';

const StyledRow = styled(Grid)`
    background: #fff url(${fondoLogin1});
    background-position: top center;
    background-repeat: no-repeat;
    background-size: contain;
`;

const StyledCol = styled(Grid)`
    background: #f6f8fa;
`;

const Container = ({
    createAccount,
    errors,
    initialValues,
    isLoadingSession,
    redirect,
}) => {
    const { t } = useTranslation();
    const isGuess = getIsGuess();
    const loadingContext = useContext(LoadingContext);

    useEffect(() => {
        if (!isGuess) redirect('/');
    }, []);

    const handleSubmit = (values) => createAccount(values, loadingContext);

    return (
        <Grid
            container
            spacing={0}
            sx={{ height: '100%', alignItems: 'center' }}
        >
            <Grid size="grow" sx={{ height: '100%', alignItems: 'center' }}>
                <StyledRow
                    container
                    spacing={0}
                    justifyContent="center"
                    sx={{ height: '100%', alignItems: 'center' }}
                >
                    <Grid size={14}>
                        <Box
                            sx={{
                                mb: 2,
                                textAlign: 'center',
                            }}
                        >
                            <img src={logotipo} width="238" />
                        </Box>

                        <h1>{t('Welcome!')}</h1>
                        <p>{t('To begin adding this data')}</p>

                        <CreateAccountForm
                            initialValues={initialValues}
                            onSubmit={handleSubmit}
                            isLoadingSession={isLoadingSession}
                            errors={errors}
                        />

                        <Box sx={{ textAlign: 'center', py: 2 }}>
                            <Button
                                component={RouterLink}
                                to="/login"
                                variant="text"
                            >
                                {t('Log in')}
                            </Button>
                        </Box>
                    </Grid>
                </StyledRow>
            </Grid>

            <StyledCol
                size={{ lg: 9 }}
                sx={{
                    alignItems: 'center',
                    display: { lg: 'flex', xs: 'none' },
                    height: '100%',
                }}
            ></StyledCol>
        </Grid>
    );
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getErrorsLogin,
    initialValues: selectors.getInitialValues,
    isLoadingSession: selectors.getIsLoadingSession,
});

const mapDispatchToProps = (dispatch) => ({
    createAccount: (values, loadingContext) =>
        dispatch(createAccount(values, loadingContext)),
    redirect: (link) => dispatch(push(link)),
});

Container.propTypes = {
    createAccount: PropTypes.func,
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    redirect: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
